export type ValidateReason =
  | 'currentRequired'
  | 'lengthRange'
  | 'sameAsCurrent'
  | 'confirmMismatch'

export type ValidateResult = { ok: true } | { ok: false; reason: ValidateReason }

export function validateNewPassword(input: {
  current: string
  next: string
  confirm: string
}): ValidateResult {
  if (input.current.length === 0) return { ok: false, reason: 'currentRequired' }
  if (input.next.length < 4 || input.next.length > 8) {
    return { ok: false, reason: 'lengthRange' }
  }
  if (input.next === input.current) return { ok: false, reason: 'sameAsCurrent' }
  if (input.next !== input.confirm) return { ok: false, reason: 'confirmMismatch' }
  return { ok: true }
}
